import { EVENT_CATEGORIES, HIT_TYPE, EVENT_NAMES } from 'app-webtech-core/beacon/const';
import { selectors } from '../../../selectors';
import { type2Beacon } from '../../../beacon';
import { LAUNCH_STATE } from '../../application/constants';
import { LOAD as PLAYER_LOAD } from '../actions/types';
import { PLAYER_CONTENT_KIND } from '../constants';

/*
 * Fires whenever the app requests a Video to be played.
 * Doesn't necessarily mean that the video starts playing, just that it makes the request.
 */

const getChannelID = ({ kind, id }, isViralEnabled) => {
  if (kind && kind === PLAYER_CONTENT_KIND.VOD) {
    return 'vod';
  } else if (isViralEnabled) {
    return 'viral';
  }
  return id;
};

// eslint-disable-next-line no-unused-vars
export const videoRequestBeacon = (action, prevState, nextState) => {
  const { launchState } = selectors.application.properties(prevState);
  const isViralEnabled = prevState.viral.isEnabled;
  if (action.type === type2Beacon(PLAYER_LOAD)) {
    if (launchState === LAUNCH_STATE.APP_LOADED) {
      return undefined; // do not send videoRequest beacon if app already launched
    }
    return {
      hitType: HIT_TYPE.EVENT,
      eventCategory: EVENT_CATEGORIES.BACKGROUND,
      eventName: EVENT_NAMES.VIDEO_REQUEST,
      channelID: getChannelID(action.payload, isViralEnabled),
      previousChannelID: 'na',
      episodeID: 'na',
      clipID: 'na',
      programTimelineID: 'na',
    };
  }
  if (action.payload.videoRequested) {
    const { previousContentKind } = selectors.guide.properties(prevState);
    const prevContentKind =
      previousContentKind && previousContentKind !== PLAYER_CONTENT_KIND.LINEAR_CHANNEL
        ? previousContentKind.toLowerCase()
        : 'na';

    return {
      hitType: HIT_TYPE.EVENT,
      eventCategory: EVENT_CATEGORIES.BACKGROUND,
      eventName: EVENT_NAMES.VIDEO_REQUEST,
      channelID: getChannelID(action.payload, isViralEnabled),
      previousChannelID: prevContentKind,
      episodeID: 'na',
      clipID: 'na',
      programTimelineID: 'na',
    };
  }
  return undefined;
};
